import axios from "axios";
import { message } from "antd";

const defaultBaseUrl = process.env.REACT_APP_BASE_URL;
export const baseUrl = defaultBaseUrl;
export const prefix = "api/";

export const ApiUrl = {
  register: {
    phone_post: "public/v1/user/lawone-register",
    phoneCode_post: "public/v1/user/register/activate",
    thirdParty: "public/v1/user/register/third-party",
    linkedin: "public/v1/user/temp/username/",
    getToken_post: "oauth/token",
  },
  faq: {
    faq_get: "public/v1/faq/que-ans",
  },
};

const logoutMechanism = () => {
  sessionStorage.clear();
  localStorage.clear();
  if (window.location.pathname.search("/login") < 0) {
    window.location.pathname = "/login";
  }
};

export const HttpService = axios.create({
  baseURL: baseUrl + prefix,
  headers: {
    Authorization: localStorage.getItem("access_token")
      ? `Bearer ${localStorage.getItem("access_token")}`
      : "",
    "Cache-Control": "no-cache",
    crossDomain: true,
    Accept: "application/json",
    "Content-Type": "application/json",
    lang: "fa",
  },
});

HttpService.interceptors.request.use(
  (config) => {
    const { headers } = config;

    const auth = headers?.Authorization;

    if (headers && localStorage.getItem("access_token")) {
      headers.Authorization = `Bearer ${localStorage.getItem("access_token")}`;
    }

    if (!auth || (auth && auth === "Bearer null")) {
      return Promise.reject(config);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

HttpService.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (!error || !error.response) {
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    if (error.response.status === 401) {
      const ref_token = localStorage.getItem("refresh_token");
      const token_request = sessionStorage.getItem("token_request");

      if (!ref_token && !token_request) {
        logoutMechanism();
        return Promise.reject(error);
      }

      if (!token_request) {
        const timer = setTimeout(() => {
          sessionStorage.setItem("token_request", "1");
        }, 2000);
        if (!ref_token) {
          logoutMechanism();
        }

        const refreshRetry = await new Promise((resolve, reject) => {
          axios
            .post(
              `${baseUrl}oauth/token?refresh_token=${ref_token}&grant_type=refresh_token`,
              {},
              {
                headers: {
                  Accept: "application/json;utf-8",
                  "Content-Type": "application/x-www-form-urlencoded;utf-8",
                  Authorization: "Basic c2FtcGxlQ2xpZW50OnNhbXBsZVNlY3JldA==",
                },
              }
            )
            .then((resp) => {
              clearTimeout(timer);
              sessionStorage.removeItem("token_request");

              const { access_token, refresh_token, expires_in } = resp.data;

              if (!access_token && !refresh_token) {
                logoutMechanism();
              }

              if (access_token) {
                localStorage.setItem("access_token", access_token);
              }

              if (refresh_token) {
                localStorage.setItem("refresh_token", refresh_token);
              }

              if (expires_in) {
                localStorage.setItem("expires_in", expires_in);
              }

              axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;

              originalRequest.headers.Authorization = `Bearer ${access_token}`;

              resolve(axios(originalRequest));
            })
            .catch((err) => {
              logoutMechanism();
              reject(Promise.reject(err));
            });
        });

        return refreshRetry;
      }
    }

    // 500
    if (error.response.status === 500) {
      const lastError = localStorage.getItem("500");
      const t = new Date().getTime();

      if (lastError) {
        if (t - Number(lastError) > 60000) {
          localStorage.setItem("500", t.toString());
          message.error("خطا در شبکه");
        }
      } else {
        localStorage.setItem("500", t.toString());
        message.error("خطا در شبکه");
      }
      return Promise.reject(error);
    }

    if (
      error.response.data &&
      (error.response.data.errors || error.response.data.message)
    ) {
      const { message: messageServer } = error.response.data;
      if (messageServer && messageServer !== "Bid not found.") {
        message.error(messageServer);
      }

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default HttpService;
